@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="row-container small">
        <app-ice-visuals-dashboard-pie-chart
            [segments]="quantityScoreSegments()"
            [centerLabel]="quantityScoreCenterLabel()"
            [loading]="dataService.loading()"
            [variant]="pieChartVariantEnum.SMALL"
        />
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <app-ice-visuals-dashboard-pie-chart
        [segments]="quantityScoreSegments()"
        [centerLabel]="quantityScoreCenterLabel()"
        [valueColumnHeader]="'dashboard.visuals.widgets.quantityScore.tableLabel' | translate"
        [labelColumnHeader]="'dashboard.visuals.widgets.quantityScore.photoCountLabel' | translate"
        [loading]="dataService.loading()"
        [variant]="pieChartVariantEnum.LARGE"
    />
}
